import { render, staticRenderFns } from "./VersionListItem.vue?vue&type=template&id=f6f52198&scoped=true"
import script from "./VersionListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./VersionListItem.vue?vue&type=script&setup=true&lang=js"
import style0 from "./VersionListItem.vue?vue&type=style&index=0&id=f6f52198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f52198",
  null
  
)

export default component.exports